import { useEffect } from 'react';
import type React from 'react';

import { Link, SocialSharing as SocialIcon, SocialSharingGroup as SocialIconsGroup, Text } from '@change/ds-core-ui';

import { useElectionsData } from './hooks/useElectionsData';

export const WebsitesContainer: React.FC = () => {
	const {
		data: { personalWebsite, socialLinks },
	} = useElectionsData();

	if (!personalWebsite && socialLinks.length === 0) return null;

	return <Websites />;
};

const Websites: React.FC = () => {
	const {
		data: { displayName, personalWebsite, socialLinks },
		actions: { trackView, handleTrackLinkClick },
	} = useElectionsData();

	useEffect(() => {
		trackView();
	}, [trackView]);

	return (
		<div className="flex flex-col px-4 md:px-0" data-testid="dm-websites-container">
			<Text size="x-large" fontWeight="bold" className="text-typography-strong mb-2">
				Connect with {displayName}
			</Text>

			{personalWebsite && (
				<Link
					href={personalWebsite}
					target="_blank"
					rel="noopener"
					data-qa="dm-personal-website-link"
					onClick={() => handleTrackLinkClick({ platform: 'personal_website', url: personalWebsite })}
				>
					<Text size="large" className="text-typography-strong">
						{personalWebsite}
					</Text>
				</Link>
			)}

			<SocialIconsGroup className="my-6 flex justify-start gap-2.5">
				{socialLinks.map(({ platform, url, icon: Icon, variant }) => (
					<Link
						key={`Share_${platform}`}
						href={url}
						target="_blank"
						rel="noopener"
						data-qa={`dm-social-link_${platform}`}
						onClick={() => handleTrackLinkClick({ platform, url })}
					>
						<SocialIcon
							aria-label={platform}
							label={platform}
							icon={<Icon />}
							size="large"
							variant={variant}
							data-qa={platform}
						/>
					</Link>
				))}
			</SocialIconsGroup>
		</div>
	);
};
